import{useContext as t}from"react";import{ReCaptchaContext as o}from"../contexts/index.js";const e=()=>t(o);export{e as useReCaptchaContext};
